<script setup lang="ts">
import { computed } from "vue";
const props = defineProps<{
  colorClass?: string;
  label: string;
  labelClass?: string;
  bgHex?: string;
}>();
const styles = computed(() => (props.bgHex ? { background: props.bgHex } : {}));
</script>

<template>
  <span
    class="flex items-center text-sm font-medium text-gray-900 dark:text-white"
  >
    <span
      class="flex w-2.5 h-2.5 rounded-full me-1.5 shrink-0"
      :class="colorClass"
      :style="styles"
    ></span>
    <span :class="labelClass">
      {{ label }}
    </span>
  </span>
</template>
